import * as React from 'react';
import { Pressable, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Card, Text } from '@/ui';
import { Icon } from '@/ui/icon';
import { Bolt } from '@/ui/icons/bolt';

interface ModelTypeCardItemProps {
  title: string;
  body: string;
  cost: string;
  unit: string;
  style?: any;
  disabled?: boolean;
  active?: boolean;
  onPress?: () => void;
}

export const ModelTypeCardItem = ({
  title,
  body,
  cost,
  unit,
  style,
  disabled = false,
  active = false,
  onPress,
}: ModelTypeCardItemProps) => {
  const { styles, theme } = useStyles(stylesheet);
  const [hover, setHover] = React.useState(false);

  const getStyle = () => {
    const showDisabled = disabled;
    let stateStyle = styles.default;

    if (hover) {
      stateStyle = styles.hover;
    }
    if (active) {
      stateStyle = styles.active;
    }
    if (showDisabled) {
      stateStyle = styles.disabled;
    }

    return [stateStyle];
  };

  return (
    <Pressable
      style={[styles.container, style]}
      onHoverIn={() => setHover(true)}
      onHoverOut={() => setHover(false)}
      hitSlop={8}
      onPress={() => {
        onPress?.();
      }}
    >
      <Card style={[styles.card, getStyle()]}>
        <View style={styles.cardContentContainer}>
          <View style={{ gap: 4 }}>
            <Text type="bodyBold">{title}</Text>

            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                gap: 4,
              }}
            >
              <Icon
                type="naked"
                icon={<Bolt />}
                fillColor={theme.colors.success}
                width={12}
                height={12}
              />

              <Text
                type="caption1"
                style={{
                  color: theme.colors.text.secondary,
                }}
              >
                {body}
              </Text>
            </View>
          </View>

          <View
            style={{ flexDirection: 'row', alignItems: 'flex-end', gap: 4 }}
          >
            <Text type="bodyBold">{cost}</Text>

            <Text
              type="caption1"
              style={{ color: theme.colors.text.secondary }}
            >
              {unit}
            </Text>
          </View>
        </View>
      </Card>
    </Pressable>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    width: '100%',
    gap: 8,
  },
  card: {
    flex: 1,
    padding: 16,
    gap: 8,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cardContentContainer: {
    flexDirection: {
      xs: 'row',
      md: 'column',
    },
    gap: 16,
    alignItems: {
      xs: 'center',
      md: 'flex-start',
    },
    justifyContent: 'space-between',
    width: {
      xs: '100%',
      md: '100%',
    },
  },
  default: {
    backgroundColor: theme.colors.card.default.backgroundColor,
    borderColor: theme.colors.card.default.borderColor,
  },
  active: {
    backgroundColor: theme.colors.card.active.backgroundColor,
    borderColor: theme.colors.card.active.borderColor,
    borderWidth: 1,
  },
  hover: {
    backgroundColor: theme.colors.card.hover.backgroundColor,
    borderColor: theme.colors.card.hover.borderColor,
  },
  disabled: {
    backgroundColor: theme.colors.card.disabled.backgroundColor,
    borderColor: theme.colors.card.disabled.borderColor,
    opacity: 0.4,
  },
}));
